import React from 'react';
import { fields as defaultFields } from '@panneau/medias';
import MediaGallery from "@micromag/media-gallery";
import { FormattedMessage } from 'react-intl';

const CustomizedMediaGallery = ({ ...props }) => {
    const fields = [
        ...defaultFields,
        {
            id: 'jobs',
            component: 'MediaJobs',
            label: <FormattedMessage defaultMessage="Conversions" description="Field title" />,
        },
    ];

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <MediaGallery fields={fields} {...props} />
};

export default CustomizedMediaGallery;
